import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { t } from 'i18next';
import styled from 'styled-components';

// import { renderErrorMessage } from 'services/errorMessages';

// import BubbleAmazed from 'asset/img/bubble-amazed.png';
// import BubbleLobed from 'asset/img/bubble-loved.svg';
// import BubbleSick from 'asset/img/bubble-sick.png';

type Props = {
  resetErrorBoundary: (...args: any[]) => void;
  error: any;
};

const GeneralErrorBoundaryUI: FC<Props> = ({ resetErrorBoundary, error }) => {
  const navigate = useNavigate();
  const errorStatusCode = error.response?.data?.statusCode;

  return (
    <SWrapper>
      <SButtonWrapper>
        {errorStatusCode >= 500 && <SButton onClick={() => resetErrorBoundary()}>다시 시도하기</SButton>}
        <SButton onClick={() => navigate('/')}>홈으로 돌아가기</SButton>
      </SButtonWrapper>
    </SWrapper>
  );
};

export default GeneralErrorBoundaryUI;

const SMainBubbleImg = styled.img`
  position: relative;
`;

const SWrapper = styled.section`
  padding: 14% 16px;
  box-sizing: border-box;
  flex: 1 1 auto;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;
  background-color: white;
`;

const SErrorText = styled.p`
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #131415;
  white-space: pre-line;

  .gray-text {
    color: #9f9f9f;
    font-size: 16px;
    font-weight: normal;
  }
`;

const SButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;

  button {
    width: 200px;
    border-radius: 10px;
  }
`;

const SButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 155px;
  width: 100%;
  height: 46px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  box-sizing: border-box;
  color: ${({ theme }) => theme.color.static.white};
  background: ${({ theme }) => theme.color.static.primary};
  font-weight: 500;
`;

const SBox = styled.div`
  margin: 60px 20px 0;
  max-width: calc(1220px + 16px * 2);
  width: 100%;
  height: 100px;
  display: flex;
  align-items: end;
  justify-content: center;
  gap: 20px;
  background: #f0f5fa;
  border: 1px solid #d6deeb;
  text-align: center;
  box-sizing: border-box;
  border-radius: 8px;
  transition: all 0.5s;
  cursor: pointer;

  :hover {
    background: #ebf6ff;
  }

  .text-wrapper {
    height: 100%;
    display: flex;
    align-items: start;
    justify-content: center;
    flex-direction: column;

    .head-text {
      font-size: 20px;
      font-weight: 700;
      color: #0067de;
    }

    .body-text {
      cursor: pointer;
      font-size: 14px;
    }
  }

  @media screen and (max-width: 480px) {
    padding: 10px;
    height: 130px;
    flex-direction: column;
    justify-content: end;
    align-items: center;
    gap: 10px;
    box-sizing: border-box;

    .bubble-image {
      width: 100px;
    }
    .text-wrapper {
      height: fit-content;
      align-items: center;
    }
  }
`;
